// @ts-nocheck
import * as _139 from "./abci/types";
import * as _140 from "./crypto/keys";
import * as _141 from "./crypto/proof";
import * as _142 from "./libs/bits/types";
import * as _143 from "./p2p/types";
import * as _144 from "./types/block";
import * as _145 from "./types/evidence";
import * as _146 from "./types/params";
import * as _147 from "./types/types";
import * as _148 from "./types/validator";
import * as _149 from "./version/types";
export namespace tendermint {
  export const abci = {
    ..._139
  };
  export const crypto = {
    ..._140,
    ..._141
  };
  export namespace libs {
    export const bits = {
      ..._142
    };
  }
  export const p2p = {
    ..._143
  };
  export const types = {
    ..._144,
    ..._145,
    ..._146,
    ..._147,
    ..._148
  };
  export const version = {
    ..._149
  };
}